module.exports = __webpack_public_path__ + "img/analogo.1fc18ca2.svg";